export enum TaskType {
  ACCEPT_CAMPAIGN_BANNERS = 'ACCEPT_CAMPAIGN_BANNERS',
}

export interface ITask {
  type: TaskType;
  params?: Record<string, unknown>;
}

export interface ITasksQueueState {
  tasks: ITask[];
}
